

























































import { Component, Vue } from 'vue-property-decorator';
import { CurbsideModel } from '@/models/CurbsideModel';

@Component
export default class CurbsidePopup extends Vue {
  private model: CurbsideModel = {
    curbsideModel: '',
    curbsideMake: '',
    curbsideColor: '',
  }

  private get isValid(): boolean {
    const { curbsideMake, curbsideModel, curbsideColor } = this.model;
    return Boolean(curbsideMake && curbsideModel && curbsideColor);
  }
}
